import { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { jamaahApi } from "@/lib/jamaahApi";
import { errMsg } from "@/lib/api";
import { Field } from "./JamaahFields";

export const SUGGESTION_STATUS = {
  baru: ["Baru", "bg-sky-100 text-sky-800"],
  dibaca: ["Sudah Dibaca", "bg-amber-100 text-amber-800"],
  ditindaklanjuti: ["Ditindaklanjuti", "bg-emerald-100 text-emerald-800"],
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" }) : "");

export const SaranAspirasi = () => {
  const [items, setItems] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const load = () => jamaahApi.get("/jamaah/me/suggestions").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await jamaahApi.post("/jamaah/me/suggestions", { subject, message });
      setSubject("");
      setMessage("");
      toast.success("Saran terkirim ke pengurus. Jazakumullah khairan.");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-5 gap-6" data-testid="portal-saran">
      <form onSubmit={submit} className="lg:col-span-2 rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-4 self-start">
        <h3 className="font-bold text-emerald-950">Kirim Saran / Aspirasi</h3>
        <Field id="saran-subject" label="Judul (opsional)">
          <Input id="saran-subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Misal: Usulan kajian pemuda" data-testid="saran-subject-input" />
        </Field>
        <Field id="saran-message" label="Isi Pesan" required>
          <Textarea id="saran-message" rows={5} value={message} onChange={(e) => setMessage(e.target.value)} required minLength={3} placeholder="Tuliskan saran, masukan, atau aspirasi Anda untuk pengurus DKM..." data-testid="saran-message-input" />
        </Field>
        <Button type="submit" className="rounded-full emerald-bg hover:bg-[#145c48]" disabled={sending} data-testid="saran-submit-btn">
          {sending ? <Loader2 className="animate-spin" size={16} /> : <><Send size={15} /> Kirim</>}
        </Button>
      </form>
      <div className="lg:col-span-3 space-y-3">
        <h3 className="font-bold text-emerald-950">Riwayat Saran Saya</h3>
        {items.length === 0 ? (
          <p className="rounded-2xl border border-dashed border-emerald-900/15 p-8 text-center text-sm text-slate-500" data-testid="saran-empty">Belum ada saran terkirim.</p>
        ) : items.map((s) => {
          const [label, cls] = SUGGESTION_STATUS[s.status] || [s.status, ""];
          return (
            <div key={s.id} className="rounded-2xl border border-emerald-900/10 bg-white p-5" data-testid={`saran-item-${s.id}`}>
              <div className="flex items-start justify-between gap-3">
                <p className="font-semibold text-emerald-950">{s.subject || "Tanpa judul"}</p>
                <Badge className={cls}>{label}</Badge>
              </div>
              <p className="mt-2 text-sm text-slate-700 whitespace-pre-wrap">{s.message}</p>
              <p className="mt-2 text-xs text-slate-400">{fmtDateTime(s.created_at)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
